import { useParams, useNavigate, useLocation } from "react-router-dom";
import HeroBanner from "../DynamicHero";
import { useEffect, useState } from "react";
import ProductDetail from "./ProductDetail";
import ProductSidebar from "./ProductSidebar";
import { Product, ProductCategory } from "../../types/Generic";
import MobileProductSidebar from "./MobileProductSidebar";
import { useTranslation } from "react-i18next";

interface ProductPageProps {
  productCategory: ProductCategory;
}

const EshopProductDetailPage: React.FC<ProductPageProps> = ({
  productCategory,
}) => {
  const currentPath = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [activeProduct, setActiveProduct] = useState<Product | undefined>();

  const path = currentPath["*"];
  const productSlug = path?.split("p=")[1];
  const location = useLocation();

  useEffect(() => {
    if (productCategory?.products?.length) {
      const foundProduct =
        productCategory.products.find(
          (p) => p.title.toLowerCase().replace(/\s+/g, "-") === productSlug
        ) || productCategory.products[0];

      if (foundProduct) {
        setActiveProduct(foundProduct);

        const foundProductSlug = foundProduct.title
          .toLowerCase()
          .replace(/\s+/g, "-");
        if (!productSlug || productSlug !== foundProductSlug) {
          navigate(`${productCategory.path}/p=${foundProductSlug}`, {
            replace: true,
            state: { preserveScroll: false },
          });
        }

        if (!location.state?.preserveScroll) {
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }
      }
    }
  }, [productCategory, productSlug, location.state, navigate]);

  const handleProductClick = (product: Product) => {
    setActiveProduct(product);
    navigate(
      `${productCategory.path}/p=${product.title.toLowerCase().replace(/\s+/g, "-")}`,
      { replace: true, state: { preserveScroll: true } }
    );
  };

  return (
    <>
      <HeroBanner text={t(productCategory.title || "Eshop")} />
      <div className="px-[5%] py-8 sm:py-12">
        <section className="gap-8 maxContainer sm:flex">
          <div className="h-max">
            <MobileProductSidebar
              productCategory={productCategory}
              onProductSelect={handleProductClick}
            />
            <ProductSidebar
              productCategory={productCategory}
              onProductSelect={handleProductClick}
            />
          </div>
          <ProductDetail product={activeProduct} />{" "}
        </section>
      </div>
    </>
  );
};

export default EshopProductDetailPage;
